import { reducer as reducer_oidc } from "redux-oidc";
import reportReducer from "./report-reducers";

const reducer = (state, action) => {
    return {
        oidc: reducer_oidc(state?.oidc, action), // Authentification
        reportApp: reportReducer(state?.reportApp, action) // Report data
    };
};
export default reducer;
